import { createToast } from "#src/common/system/toasts";
import { ButtonV2 } from "#src/commonV2/Button";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";
import dlpService from "#src/services/endpoint/dlp";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import { useTranslation } from "react-i18next";

interface IEndpointDlpBackupResetModalProps {
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onRefresh: () => void;
}

export const EndpointDlpBackupResetModal = ({
  workspaceId,
  open,
  onClose,
  onRefresh,
}: IEndpointDlpBackupResetModalProps) => {
  const { t } = useTranslation("endpoint", {
    keyPrefix: "dlp.backupSettings.backupStorage.resetModal",
  });

  // --------------- HOOKS ---------------

  // --------------- METHODS ---------------

  const onReset = () => {
    dlpService
      .updateBackupSettings(workspaceId, {
        storage: null,
        storage_access_id: null,
        storage_secret_key: null,
        storage_region: null,
        storage_bucket: null,
        storage_arn: null,
      })
      .then((response) => {
        if (response.success) {
          onRefresh();
          onClose();
          createToast({
            type: "success",
            message: t("notification.success.message"),
          });
        } else {
          createToast({
            type: "error",
            message: t("notification.failed.message", { name: response.error }),
            detail: t("notification.failed.detail"),
          });
        }
      })
      .catch(apiErrorHandler);
  };

  // --------------- RENDER ---------------

  return (
    <ModalV2 open={open} onChangeOpen={onClose} className="w-[34rem]">
      <span className="text-lg font-semibold text-gray-v2-900">
        {t("title")}
      </span>
      <span className="text-md text-gray-v2-600">{t("hint")}</span>
      <div className="flex justify-end gap-2">
        <ButtonV2 variant="secondary" color="gray" onClick={onClose}>
          {t("button.cancel")}
        </ButtonV2>
        <ButtonV2 onClick={onReset} color="error">
          {t("button.confirm")}
        </ButtonV2>
      </div>
    </ModalV2>
  );
};
